import {useSearchParams} from 'react-router-dom';
import {MaterialType} from 'components/customer/Materials/entity/MaterialType';

export const useMaterialType = (isExterior: boolean) => {
    const [query] = useSearchParams();

    const materialType = isExterior
        ? MaterialType.EXTERIOR
        : MaterialType.CARCASE;

    const cabinetType = query.has('product')
        ? Number(query.get('product'))
        : undefined;

    return {
        materialType,
        cabinetType,
    };
};
